const TwitterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M24 4.30952C23.1174 4.70061 22.1693 4.96486 21.1726 5.08429C22.1894 4.47547 22.9694 3.50938 23.3373 2.35938C22.386 2.92381 21.3322 3.33392 20.2107 3.55377C19.3123 2.59826 18.0333 2 16.6169 2C13.8984 2 11.6935 4.20488 11.6935 6.92557C11.6935 7.31031 11.7379 7.68449 11.8203 8.04598C7.72659 7.83987 4.10006 5.87915 1.6711 2.90055C1.2483 3.62988 1.0052 4.47547 1.0052 5.37602C1.0052 7.08412 1.8751 8.59244 3.19528 9.47503C2.38774 9.4486 1.62882 9.22769 0.965031 8.8588V8.92222C0.965031 11.3078 2.6615 13.2982 4.915 13.7506C4.50066 13.8626 4.06624 13.9218 3.61807 13.9218C3.30098 13.9218 2.99128 13.8922 2.69109 13.8351C3.31789 15.7905 5.13591 17.2154 7.29111 17.2534C5.60521 18.5747 3.48172 19.3621 1.17537 19.3621C0.777944 19.3621 0.385801 19.3389 0 19.2934C2.17951 20.6918 4.76702 21.5057 7.5469 21.5057C16.6053 21.5057 21.5573 14.0032 21.5573 7.49634C21.5573 7.28495 21.552 7.07143 21.5425 6.86004C22.5044 6.16454 23.3394 5.29886 23.9979 4.31269L24 4.30952Z"
          fill="#1D9BF0"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TwitterIcon;
